import { baseApi } from "@/redux/api/baseApi";
import { tagTypes } from "@/redux/tagTypes";

export const optVerificationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    senOTP: builder.mutation({
      query: (data) => ({
        url: "/otp/send",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [tagTypes.otp],
    }),
    verifyOTP: builder.mutation({
      query: (data) => ({
        url: "/otp/verify",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [tagTypes.otp],
    }),
  }),
});

export const { useSenOTPMutation, useVerifyOTPMutation } = optVerificationApi;
